export default __webpack_public_path__ + "media/react/gmat/organisms/official_practice_tests_card/practice_exams_1_2-01f49cbffa2269f97d1de6493a8fb929.png";